import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurladdress } from "../baseurl"
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { NavLink } from "react-router-dom";

function AddLeaveSettings() {
    const accessuserid = localStorage.getItem("id");
    const username = localStorage.getItem("username");

    const accesstoken = localStorage.getItem("token");
    const navigate = useNavigate();
    const Swal = require('sweetalert2')



    const [leavetypedata, setleavetypedata] = useState([]);
    const [leavetype, setleavetype] = useState("");
    const [maxleave, setmaxleave] = useState("");
    const [appworkingdays, setappworkingdays] = useState("");
    const [maxconsec, setmaxconsec] = useState("");
    const [carryforward, setcarryforward] = useState("");
    const [withoutpay, setwithoutpay] = useState("");
    const [partialpay, setpartialpay] = useState("");
    const [optionalleave, setoptionalleave] = useState("");
    const [compensatoryleave, setcompensatoryleave] = useState("");





    // const handleSubmit = (event) => {

    //     event.preventDefault();
    //     const data = {
    //         leave_type: leavetype,
    //         max_leave: maxleave,
    //         leave_applicabledays: appworkingdays,
    //         leave_consecutivedays: maxconsec,
    //         leave_carryforward: carryforward,
    //         leave_withoutpay: withoutpay,
    //         leave_partialpay: partialpay,
    //         leave_optional: optionalleave,
    //         leave_compensatory: compensatoryleave,
    //         userid: accessuserid

    //     };


    //     fetch(
    //         baseurladdress + `addleaves`,
    //         {
    //             method: "POST",

    //             body: JSON.stringify(data),
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 Authorization: `Bearer ${accesstoken}`,
    //             },
    //         }
    //     )
    //         .then((res) => res.json())
    //         .then((result) => {
    //             if (result["status"] === "success") {

                   
    //                 const Toast = Swal.mixin({
    //                     toast: true,
    //                     position: 'top-end',
    //                     showConfirmButton: false,
    //                     timer: 400,
    //                     timerProgressBar: true,
    //                     didOpen: (toast) => {
    //                         toast.addEventListener('mouseenter', Swal.stopTimer)
    //                         toast.addEventListener('mouseleave', Swal.resumeTimer)
    //                     }
    //                 })
    //                 Toast.fire({
    //                     icon: 'success',
    //                     title: 'Leave Type added successfully'
    //                 })

                  
    //                 navigate("/leavesettings");
    //             }
    //         });
    // };


    const handleSubmit = async (event) => {
        event.preventDefault();
    
       
        if (!leavetype || leavetype.trim() === "") {
            Swal.fire({
                icon: 'error',
                title: 'Leave Type is required',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true,
            });
            return;
        }
    
        
        const existingLeaveTypesData = await fetch(baseurladdress + `findallleaves`, {
            headers: {
                Authorization: `Bearer ${accesstoken}`,
            },
        }).then(res => res.json());
        
        const existingLeaveTypes = existingLeaveTypesData.response || [];
        
        const isDuplicate = existingLeaveTypes.some(type => 
            type.leave_type?.trim().toLowerCase() === leavetype.trim().toLowerCase()
        );
        
        if (isDuplicate) {
            Swal.fire({
                icon: 'error',
                title: 'Leave Type already exists',
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true,
            });
            return;
        }
        
    
        const data = {
            leave_type: leavetype,
            max_leave: maxleave,
            leave_applicabledays: appworkingdays,
            leave_consecutivedays: maxconsec,
            leave_carryforward: carryforward,
            leave_withoutpay: withoutpay,
            leave_partialpay: partialpay,
            leave_optional: optionalleave,
            leave_compensatory: compensatoryleave,
            userid: accessuserid
        };
    
        fetch(baseurladdress + `addleaves`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accesstoken}`,
            },
        })
        .then((res) => res.json())
        .then((result) => {
            if (result["status"] === "success") {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 1500,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                });
    
                Toast.fire({
                    icon: 'success',
                    title: 'Leave Type added successfully'
                });
    
                navigate("/leavesettings");
            } 
        });
    };
    


    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <div class="content-wrap">
                <div className="container-fluid">
                    <NavLink activeClassName="active-link" to={"/leavesettings"}>
                        <div style={{ display: "flex" }}>
                            <a class="float ">
                                <i class="fa fa-arrow-left my-float" style={{ "marginTop": "21px" }}></i>
                            </a>
                        </div>
                    </NavLink>

                    <form>

                        <div className='row'>
                            <div class="col-xl-12 col-xxl-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h4 class="card-title">Leave Type Details</h4>
                                    </div>
                                    <div class="card-body">
                                        <div class="basic-form">

                                            <div className='row'>
                                                <div class="col-xl-6 col-xxl-12">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="basic-form">
                                                                <div class="form-row">
                                                                    <div class="col-sm-12 mt-2 mt-sm-0">
                                                                        <h6>Leave Type</h6>
                                                                        <input type="text"
                                                                            class="form-control"
                                                                            placeholder='Type'
                                                                            value={leavetype}
                                                                            onChange={(e) => setleavetype(e.target.value)}

                                                                        />
                                                                    </div>
                                                                    <div class="col-sm-12 mt-3 mt-sm-0">
                                                                        <h6>Maximum Leave Allocation Allowed</h6>
                                                                        <input type="text"
                                                                            class="form-control"
                                                                            placeholder='No of Days'
                                                                            value={maxleave}
                                                                            onChange={(e) => setmaxleave(e.target.value)}
                                                                        />
                                                                    </div>
                                                                    <div class="col-sm-6 mt-3 mt-sm-0">
                                                                        <h6>Applicable After (Working Days)</h6>
                                                                        <input type="text"
                                                                            class="form-control"
                                                                            placeholder='No of Days'
                                                                            value={appworkingdays}
                                                                            onChange={(e) => setappworkingdays(e.target.value)}
                                                                        />
                                                                    </div>
                                                                    <div class="col-sm-6 mt-3 mt-sm-0">
                                                                        <h6>Maximum Consecutive Leaves Allowed</h6>
                                                                        <input type="text"
                                                                            class="form-control"
                                                                            placeholder='No of Consecutive Leaves Allowed'
                                                                            value={maxconsec}
                                                                            onChange={(e) => setmaxconsec(e.target.value)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-xl-6 col-xxl-12">
                                                    <div class="card">
                                                        <div class="card-body">
                                                            <div class="basic-form">
                                                                <div class="form-row">
                                                                    <div class="col-sm-12 mt-2 mt-sm-0">
                                                                        <div class="form-check mb-2 button">
                                                                            {/* <input type="checkbox" class="form-check-input" id=""    value={carryforward}
                                                                            onChange={(e) => setcarryforward(e.target.value)}/> */}
                                                                            <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="carryforwardCheckbox"
                                                                                checked={carryforward === 1}
                                                                                onChange={(e) => setcarryforward(e.target.checked ? 1 : 0)}
                                                                            />
                                                                            <h6 class="form-check-label" for="" style={{ "text-align": "left" }} >Is Carry Forward?</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-12 mt-2 mt-sm-0">
                                                                        <div class="form-check mb-2 button">
                                                                            {/* <input type="checkbox" class="form-check-input" id="" value={withoutpay}
                                                                                onChange={(e) => setwithoutpay(e.target.value)} /> */}
                                                                                 <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="carryforwardCheckbox"
                                                                                checked={withoutpay === 1}
                                                                                onChange={(e) => setwithoutpay(e.target.checked ? 1 : 0)}
                                                                            />
                                                                            <h6 class="form-check-label" for="" style={{ "text-align": "left" }} >Is Leave Without Pay?</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-12 mt-2 mt-sm-0">
                                                                        <div class="form-check mb-2 button">
                                                                            {/* <input type="checkbox" class="form-check-input" id="" value={partialpay}
                                                                                onChange={(e) => setpartialpay(e.target.value)} /> */}
                                                                                 <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="carryforwardCheckbox"
                                                                                checked={partialpay === 1}
                                                                                onChange={(e) => setpartialpay(e.target.checked ? 1 : 0)}
                                                                            />
                                                                            <h6 class="form-check-label" for="" style={{ "text-align": "left" }} >Is Partially Paid Leave?</h6>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-12 mt-2 mt-sm-0">
                                                                        <div class="form-check mb-2 button">
                                                                            {/* <input type="checkbox" class="form-check-input" id="" value={optionalleave}
                                                                                onChange={(e) => setoptionalleave(e.target.value)} /> */}
                                                                                  <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="carryforwardCheckbox"
                                                                                checked={optionalleave === 1}
                                                                                onChange={(e) => setoptionalleave(e.target.checked ? 1 : 0)}
                                                                            />
                                                                            <h6 class="form-check-label" for="" style={{ "text-align": "left" }} >Is Optional Leave?</h6>
                                                                            <p className='mt-2'>These leaves are holidays permitted by the company however, availing it is optional for an Employee</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-sm-12 mt-2 mt-sm-0">
                                                                        <div class="form-check mb-2 button">
                                                                            {/* <input type="checkbox" class="form-check-input" id="" value={compensatoryleave}
                                                                                onChange={(e) => setcompensatoryleave(e.target.value)} /> */}
                                                                                  <input
                                                                                type="checkbox"
                                                                                className="form-check-input"
                                                                                id="carryforwardCheckbox"
                                                                                checked={compensatoryleave === 1}
                                                                                onChange={(e) => setcompensatoryleave(e.target.checked ? 1 : 0)}
                                                                            />
                                                                            <h6 class="form-check-label" for="" style={{ "text-align": "left" }} >Is Compensatory?</h6>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                    <div class="col-12 d-flex justify-content-center mt-4">
                                        <button type="submit" class="btn btn-primary mb-2" onClick={handleSubmit}>Submit</button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>
    );
}

export default AddLeaveSettings;